<template>
  <div class="p-3 filter-container">
    <div class="col-md-12">
      <div class="row">
        <div class="col-12 col-md-4 col-lg-3 col-xl-3 py-1">
          <div class="custom-ddf">
            <ValidationObserver ref="formValidator" v-slot="{}" tag="form">
              <ValidationProvider
                v-slot="{ errors }"
                name="AcademicYear"
                rules="required"
              >
                <custom-drop-down
                  v-model="model.selectedAcademicYear"
                  required
                  :clearable="false"
                  :options="filters.academicYears"
                  placeholder="Seleccione el Año Académico"
                  :fieldkey="'id'"
                  :fieldname="'description'"
                  :error="errors[0]"
                  :custom-error-msg="errorMessage.academicYear"
                  @input="OnChange('academicYear', $event)"
                />
              </ValidationProvider>
            </ValidationObserver>
          </div>
        </div>

        <div class="col-12 col-md-4 col-lg-6 col-xl-7 py-1">
          <custom-input
            v-model="model.student"
            type="text"
            placeholder="Escriba Número de SIE, Número de Registro o Nombre del Estudiante"
            :left-icon="true"
            icon="far fa-search orange-icon "
          />
        </div>

        <div class="col-12 col-md-4 col-lg-3 col-xl-2 py-1 pl-0">
          <div class="row fr mr-sm-n4">
            <div class="col-4 col-md-4">
              <action-button
                :class="{ transparent: !this.hasAdvanceFilters }"
                class="pl-3"
                i="fal fa-sliders-v"
                variant="orange"
                @click="isAdvanced()"
              />
            </div>
            <div class="col-8 col-md-6">
              <action-button
                :disabled="false"
                text="Buscar"
                variant="success"
                class="px-4"
                @click="Search()"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="this.hasAdvanceFilters" class="col-md-12">
      <div class="row py-3">
        <div class="col-md-12">
          <span class="separator">FILTROS</span>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-md-3 pb-3">
          <div class="custom-ddf">
            <custom-drop-down
              v-model="model.selectedQuestionnaireStatus"
              fieldname="name"
              fieldkey="id"
              :options="filters.questionnaireStatus"
              placeholder="Estatus Cuestionario"
            />
          </div>
        </div>
        <div class="col-12 col-md-3 pb-3">
          <div class="custom-ddf">
            <custom-drop-down
              v-model="model.selectedRegion"
              fieldname="name"
              fieldkey="id"
              :options="filters.regions"
              placeholder="Región"
              :disabled="!model.selectedAcademicYear"
              @input="OnChange('region', $event)"
            />
          </div>
        </div>
        <div class="col-12 col-md-3 pb-3">
          <div class="custom-ddf">
            <custom-drop-down
              v-model="model.selectedDistrict"
              fieldname="name"
              fieldkey="id"
              :options="filters.districts"
              placeholder="Distrito"
              :disabled="!model.selectedRegion"
              @input="OnChange('district', $event)"
            />
          </div>
        </div>
        <div class="col-12 col-md-3 pb-3">
          <div class="custom-ddf">
            <custom-drop-down
              v-model="model.selectedSchool"
              fieldname="name"
              fieldkey="id"
              :options="filters.schools"
              placeholder="Escuela"
              :disabled="!model.selectedDistrict"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomDropDown from '@/components/common/CustomDropDown';
import CustomInput from '@/components/common/CustomInput.vue';
import { ActionButton } from '@/components/common';
import { ValidationProvider, ValidationObserver } from 'vee-validate';

export default {
  name: 'InterviewAdvancedSearch',
  components: {
    CustomDropDown,
    CustomInput,
    ActionButton,
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    model: {
      type: Object,
      default: () => {},
    },
    filters: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      advancedFilter: null,
      errorMessage: {
        academicYear: '',
      },
    };
  },
  watch: {
    selectedAcademicYear: function(previousValue, newValue) {
      this.OnChange('academicYear', newValue);
    },
  },
  computed: {
    hasAdvanceFilters() {
      if (this.advancedFilter == null) {
        return this.model.advancedFilter;
      }
      return this.advancedFilter;
    },
  },
  methods: {
    OnChange(selectedType, selectedValue) {
      this.$emit('OnChangeHandler', selectedType, selectedValue);
    },
    async Search() {
      let isValid = await this.validate();
      if (!isValid) {
        return;
      }
      this.$emit('SearchHandler');
    },
    GetMessage(code) {
      return this.getMessage(code);
    },
    isAdvanced() {
      this.model.advancedFilter = !this.model.advancedFilter;
      this.advancedFilter = this.model.advancedFilter;
      //Restart filters
      if (!this.advancedFilter) {
        this.model.selectedSchool = null;
        this.model.selectedQuestionnaireStatus = null;
        this.model.selectedRegion = null;
        this.model.selectedDistrict = null;
      }
    },
    async validate() {
      return await this.$refs.formValidator.validate();
    },
    loadValidationMessages() {
      const messageCodes = ['18018'];
      const promise = this.$ApiGet(
        '/api/validationsmessages?messageCodes=' +
          messageCodes.join('&messageCodes=')
      );
      promise.then((res) => {
        this.validationMessages = res.data;
        this.errorMessage.academicYear = this.getMessage('18018').name;
      });
    },
    getMessage(code) {
      const message = this.validationMessages.find(
        (element) => element.id == code
      );
      return message;
    },
  },
  created() {
    this.loadValidationMessages();
  },
};
</script>

<style scoped>
/* BADGES */
.badge.no-interview {
  height: 32px;
  background: #f8eb7f 0% 0% no-repeat padding-box;
  border-radius: 18px;
  opacity: 1;
  text-align: center;
  font: Bold 16px/21px Lato;
  letter-spacing: 0;
  color: #11291b;
}
.badge.completed {
  height: 32px;
  background: #a3e5b3 0% 0% no-repeat padding-box;
  border-radius: 18px;
  opacity: 1;
  text-align: center;
  font: Bold 16px/21px Lato;
  letter-spacing: 0;
  color: #11291b;
}
.btn-setting {
  background: #ff7058 0% 0% no-repeat padding-box;
  border-radius: 4px;
  border: 0px !important;
  color: #ffffff;
  opacity: 1;
}

/* FILTER CONTAINER */
.filter-container {
  background: #f4f6f3 0% 0% no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;
}

/* SEPARATOR */
.separator {
  display: flex;
  align-items: center;
  text-align: center;
  color: #aab7b1;
  font: 900 14px/17px Lato;
}
.separator::before,
.separator::after {
  content: '';
  flex: 1;
  border-bottom: 1px solid #aab7b1;
}
.separator::before {
  margin-right: 0.5em;
}
.separator::after {
  margin-left: 0.5em;
}

/* CUSTOM DROPDOWN */
.custom-ddf :placeholder-shown,
.custom-ddf .vs__search::placeholder {
  color: #495057;
  opacity: 0.8;
  line-height: 1.6;
}

.btn-setting-off {
  background-color: #f4f6f3;
  border-radius: 4px;
  border: 0px !important;
  color: #3f5b60;
}

.search-bar {
  background: #f4f6f3 0% 0% no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;
}

.title-divider {
  border: 1px solid #b5c3bc;

  opacity: 1;
}
.title-content {
  background: #3f5b60 0% 0% no-repeat padding-box;
  border-radius: 21px;
  opacity: 1;
  text-align: center;
  font: Bold 17px/23px Lato;
  letter-spacing: 0;
  color: #ffffff;
}
.filter-content {
  font: Bold 14px/17px Lato;
  letter-spacing: 0;
  color: #aab7b1;
  opacity: 1;
}

.no-info {
  background: #f7f7f7 0% 0% no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;
  border-left-style: solid;
  border-color: #e8e8e8;
  border-width: 0;
}
.no-info-text {
  text-align: left;
  font: Bold 16px/22px Lato;
  letter-spacing: 0;
  color: #727272;
  opacity: 1;
}
.no-info-icon {
  color: #727272;
  font-size: 32px;
}

.interview-status {
  height: 32px;
  background: #f8eb7f 0% 0% no-repeat padding-box;
  border-radius: 18px;
  opacity: 1;
  text-align: center;
  font: Bold 16px/21px Lato;
  letter-spacing: 0;
  color: #11291b;
}
.egress-interview {
  background: #f7f7f7 0% 0% no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;

  border-left-style: solid;
  border-color: #f8eb7f;
  border-width: 4px;
}

.btn-dropdown-actions {
  text-align: center;
  font-family: 'Lato', sans-serif;
  font-weight: 400;
  font-size: 1rem;
  color: rgb(12, 19, 16);
  border-radius: 4px;
  margin-right: 0px;
  border: 1px solid #2db782;
}
.dropdown-menu {
  margin-top: 1rem;
}

.dropdown-item {
  font: Regular 16px/19px Lato;
}

.dropdown-item i {
  margin-right: 1rem;
}

.drop-item {
  font-family: 'Lato', sans-serif;
  font-weight: 400;
  font-size: 0.9375rem;
  color: #11291b;
  text-align: inherit;
  white-space: nowrap;
  display: block;
  padding: 0.29rem 1.5rem;
  clear: both;
}

.dropdown-action-divider {
  border-top-width: 1px;
  border-top-style: solid;
  border-color: #e2e2e2;
  margin-left: 5%;
  margin-right: 5%;
}

.settings-button {
  align-content: center;

  background: #ff7058 0% 0% no-repeat padding-box;
  border-radius: 4px;
  opacity: 1;
}

.icon {
  font-size: 35px;
  height: 60px;
  width: 60px;
  border: solid 3px;
  border-radius: 127px;
  padding-top: 8px;
  padding-right: 4px;
  color: #e2e2e2;
}

.egress-interview.no-interview {
  border-color: #f8eb7f;
}

.egress-interview.completed {
  border-color: #a3e5b3;
}

.egress-interview.in-process {
  border-color: #d5b89a;
}

.was-Invalidated {
  margin-top: -10px !important;
}
</style>
